/* istanbul ignore file */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';
import styled from 'styled-components';
var FullHeightInView = styled(InView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n"], ["\n  height: 100%;\n"])));
var RenderInView = function (_a) {
    var children = _a.children, onSlideChange = _a.onSlideChange, index = _a.index;
    var slideVisible = function (inView) {
        if (inView) {
            onSlideChange(index);
        }
    };
    return (React.createElement(FullHeightInView, { "data-testid": "render-in-view-".concat(index), onChange: slideVisible }, children));
};
RenderInView.propTypes = {
    onSlideChange: PropTypes.func,
    index: PropTypes.number,
};
export { RenderInView };
var templateObject_1;
//# sourceMappingURL=RenderInView.js.map